import chatbotRequest from '@/service/channel/http'
import type { UpdateAgentStatusReq, UpdateAgentStatusRes } from '../type/updateAgentStatus'

export function updateAgentStatusApi(data: UpdateAgentStatusReq): Promise<UpdateAgentStatusRes> {
    return chatbotRequest<UpdateAgentStatusRes, UpdateAgentStatusReq, UpdateAgentStatusRes>({
        url: '/api/agent/status',
        method: 'post',
        data,
    })
}
